<template>
  <div class="container">
    <h2>Kolekcje ({{ Object.keys(cMap).length }})</h2>

    <div class="section">
      Sort:
      <a
        class="btn-small"
        v-bind:class="{ 'btn-flat': this.sortBy !== 'created' }"
        @click="sortBy = 'created'"
        ><i class="material-icons left">arrow_downward</i>created</a
      >
      <a
        class="btn-small"
        v-bind:class="{ 'btn-flat': this.sortBy !== 'updated' }"
        @click="sortBy = 'updated'"
        ><i class="material-icons left">arrow_downward</i>updated</a
      >
    </div>

    <div class="card-panel">
      <h5>Nowa Kolekcja</h5>
      <div class="row">
        <div class="input-field col s9">
          <input
            placeholder="Nazwa kolekcji"
            id="first_name"
            type="text"
            class="validate"
            ref="newCollectionName"
          />
          <label for="first_name">Nazwa kolekcji</label>
        </div>
        <div>
          <a
            class="btn-large"
            @click="onSaveNewCollection($refs.newCollectionName.value)"
            ><i class="material-icons left">save</i>Utwórz</a
          >
        </div>
      </div>
    </div>

    <div
      class="card"
      v-for="collection in sortedCollections"
      :key="collection.data.id"
    >
      <div class="card-content">
        <span class="card-title"
          >{{ collection.data.name }} ({{
            collection.data.items?.length
          }})</span
        >
        <code>id: {{ collection.data.id }}</code>
        <p v-if="collection.data.updated">
          {{ $d(new Date(collection.data.updated), "long") }}
        </p>
        <ul>
          <li v-for="item in collection.data.items" :key="item.id">
            <span class="admin-itemId">{{ item.id }}</span>
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="card-action">
        <a
          href="#"
          @click.prevent="openCB(collection.data, collection.dataRich)"
        >
          Edytuj produkty</a
        >
        <a href="#" @click.prevent="collectionToBeRenamed = collection.data">
          Zmień nazwę</a
        >
        <a
          href="#"
          @click.prevent="onDeleteSelected(collection.data)"
          class="red-text"
        >
          Kasuj</a
        >
      </div>
    </div>

    <collection-builder
      ref="builder"
      v-bind:collection="{ name: 'Promocje', id: 'collection1' }"
      :initial-items="[]"
      :on-accept-callback="
        (data) => {
          handleOnAccept(data);
        }
      "
      :on-reject-callback="
        () => {
          console.log('Rejected');
        }
      "
    ></collection-builder>

    <!-- Modal Structure -->
    <div id="modalConfirmDeletion" class="modal">
      <div class="modal-content">
        <h4>Napewno usunąć "{{ modalDeleteCollection?.name }}"?</h4>
        <code>id: {{ modalDeleteCollection.id }}</code>
        <p>Kasowanie jest nieodwracalne</p>
      </div>
      <div class="modal-footer">
        <a
          class="modal-close btn-flat text-white"
          @click="onDeleteConfirmed(modalDeleteCollection?.id)"
          >Tak, Usuń</a
        >
      </div>
    </div>

    <modal-collection-rename
      v-if="collectionToBeRenamed"
      v-on:modalClosed="collectionToBeRenamed = null"
      v-on:saved="refreshCollections()"
      :collection="collectionToBeRenamed"
    ></modal-collection-rename>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import admin from "@/admin";

export default {
  components: {
    collectionBuilder: () => import("@/views/collections/CollectionBuilder.vue"),
    modalCollectionRename: () =>
      import("@/views/collections/ModalCollectionRename.vue"),
  },

  data() {
    return {
      cMap: {},
      cbOnClose: () => {
        console.log("on close");
      },
      cbInitialItems: [],
      sortBy: "updated",
      modalDeleteCollection: "",
      collectionToBeRenamed: null, // Collection to be renamed
    };
  },

  computed: {
    sortedCollections: function () {
      return Object.values(this.cMap).sort((a, b) => {
        return this.sortBy === "created"
          ? new Date(b.data.created) - new Date(a.data.created)
          : // default to updated
            new Date(b.data.updated) - new Date(a.data.updated);
      });
    },
  },

  watch: {},

  methods: {
    openCB(collection) {
      this.$refs.builder.openModal({
        collection: collection,
        title: collection.name,
      });
    },

    async handleOnAccept(data) {
      console.log("on accept called...", data);
      //save new collection

      //on success - close modal, refresh this collection in cMap
      await axios.patch(
        process.env.VUE_APP_API +
          "/api/apiCollections/" +
          data.collectionData.id,
        { itemIds: data.items.map((item) => item.id) },
        {
          headers: {
            Authorization: "Bearer " + this.$store.getters.authToken,
          },
          params: {
            ref: "admin:collections:handleOnAccept",
          },
        },
      );
      this.$refs.builder.closeModal();
      // this.getCollectionData(data.collectionData, data.collectionData.id);
      await this.refreshCollections();
      admin.toastInfo("Zmiany zapisano");

      //on failure - do not close, show error
      //todo: handle error
    },

    getCollectionData(apiCollectionData, id) {
      axios
        .get(process.env.VUE_APP_API + "/ui/collections.json", {
          params: {
            q: "byId:" + id,
            limit: 900,
            ref: "admin:collections:getCollectionData",
          },
        })
        .then((axiosResponse) => {
          Vue.set(this.cMap, id, {
            data: {
              ...apiCollectionData,
              items: axiosResponse.data.collections?.byId,
            },
          });
        })
        .catch((error) => {
          console.error("admin:collections:created", error);
        });
    },

    async refreshCollections() {
      Vue.set(this, "cMap", {});
      const allCols = await axios
        .get(process.env.VUE_APP_API + "/api/apiCollections/list", {
          params: {
            ref: "admin:collections:created.list",
          },
          headers: {
            Authorization: "Bearer " + this.$store.getters.authToken,
          },
        })
        .then((axiosResponse) => {
          return axiosResponse.data;
        });

      const allCoolectionsIds = Object.entries(allCols).map(([key, value]) => {
        return key;
      });

      allCoolectionsIds.forEach((collection) => {
        axios
          .get(process.env.VUE_APP_API + "/api/apiCollections/" + collection, {
            params: {
              ref: "admin:collections:created",
            },
            headers: {
              Authorization: "Bearer " + this.$store.getters.authToken,
            },
          })
          .then((axiosResponse) => {
            const apiCollectionData = axiosResponse.data;
            this.getCollectionData(apiCollectionData, collection);
          })
          .catch((error) => {
            console.error("admin:collections:created", error);
          });
      });
    },

    onSaveNewCollection(name) {
      if (!name || name.trim() === "") {
        console.warn("Collection name cannot be empty");
        return;
      }
      axios
        .post(
          process.env.VUE_APP_API + "/api/apiCollections",
          { name: name, itemIds: ["xxx"] },
          {
            headers: {
              Authorization: "Bearer " + this.$store.getters.authToken,
            },
            params: {
              ref: "admin:collections:onSaveNewCollection",
            },
          },
        )
        .then((response) => {
          console.log("New collection created", response.data);
          this.refreshCollections();
          this.$refs.newCollectionName.value = ""; // Clear input field
          admin.toastInfo("Pomyślnie utworzono nową kolekcję: " + name);
        })
        .catch((error) => {
          console.error("Error creating new collection", error);
        });
    },

    onDeleteSelected(collection) {
      console.info("deleting collection", collection);
      this.modalDeleteCollection = collection;
      M.Modal.getInstance(
        document.querySelector("#modalConfirmDeletion"),
      ).open();
    },

    onDeleteConfirmed(cId) {
      console.log("doDelete called", cId);
      axios
        .delete(process.env.VUE_APP_API + "/api/apiCollections/" + cId, {
          headers: {
            Authorization: "Bearer " + this.$store.getters.authToken,
          },
          params: {
            ref: "admin:collections:onDeleteConfirmed",
          },
        })
        .then((response) => {
          console.log("Collection deleted", response.data);
          this.refreshCollections();
          admin.toastInfo("Kolekcja została usunięta");
        })
        .catch((error) => {
          console.error("Error deleting collection", error);
        });
    },
  },

  created() {
    this.refreshCollections();
  },

  mounted() {
    M.Modal.init(document.querySelectorAll("#modalConfirmDeletion"), {
      onCloseEnd: () => {
        console.log("modal on close end");
      },
    });
  },

  beforeDestroy() {},
};
</script>

<style scoped></style>
